/* This is a generated file. Do not edit manually. */
import React from 'react';
import PropTypes from 'prop-types';
import iconSizes from '../../iconSizes';

/**
 * ParkingIcon
 */
export default class ParkingIcon extends React.Component {
  static propTypes = {
    /** The size of the icon */
    size: PropTypes.oneOf(['s', 'm', 'l', 'xl']),
    /** The color of the icon */
    color: PropTypes.string.isRequired
  };

  static defaultProps = {
    size: 'm',
    color: 'black'
  };

  render() {
    const { size: sizeProp, color } = this.props;
    const size = correctButtonSize(sizeProp);
    return (
      <svg
        focusable="false"
        xmlns="http://www.w3.org/2000/svg"
        viewBox={'0 0 32 32'}
        style={{ width: iconSizes[size], height: iconSizes[size] }}
      >
        <g style={{ fill: color }}>
          <svg viewBox="0 0 24 24"><path d="M19 2a3 3 0 013 3v14a3 3 0 01-3 3H5a3 3 0 01-3-3V5a3 3 0 013-3h14zm0 2H5a1 1 0 00-1 1v14a1 1 0 001 1h14a1 1 0 001-1V5a1 1 0 00-1-1zm-6.45 2.5c1.21 0 2.16.285 2.85.855.69.57 1.035 1.4 1.035 2.49 0 1.08-.345 1.897-1.035 2.452-.69.556-1.64.833-2.85.833h-2.205v3.51a.34.34 0 01-.105.262.381.381 0 01-.27.098H8.53a.347.347 0 01-.255-.105.347.347 0 01-.105-.255V6.875c0-.11.032-.2.098-.27A.34.34 0 018.53 6.5h4.02zm-.075 1.68h-2.16v3.27h2.16c.58 0 1.022-.137 1.328-.412.305-.276.457-.678.457-1.208 0-.52-.147-.925-.442-1.215-.296-.29-.743-.435-1.343-.435z" fillRule="nonzero"/></svg>
        </g>
      </svg>
    );
  }
}

/* corrects deprecated api, can be removed in future release */
function correctButtonSize(size) {
  switch (size) {
    case 'medium':
      return 'm';
    case 'small':
      return 's';
    case 'large':
      return 'l';
    case 'xlarge':
      return 'xl';
    default:
      return size;
  }
}

